export default "__VITE_ASSET__Dnchsk1B__"